import { render, staticRenderFns } from "./transportForm.vue?vue&type=template&id=062375be&scoped=true"
import script from "./transportForm.vue?vue&type=script&lang=js"
export * from "./transportForm.vue?vue&type=script&lang=js"
import style0 from "./transportForm.vue?vue&type=style&index=0&id=062375be&prod&lang=scss"
import style1 from "./transportForm.vue?vue&type=style&index=1&id=062375be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062375be",
  null
  
)

export default component.exports